import * as utils from '../../view_invitation/utils';
import {EviteModal} from '../../modal/index'
import urls from 'urls';


// ------------------------------------------------------------------------
// -- RegistryModel -------------------------------------------------------
// ------------------------------------------------------------------------
export default class RegistryModel extends Backbone.Model {
    static setup(){
      RegistryModel.setup = evite.noop;

      window.registry_collection = new RegistryCollection();
      // Knotiness
      new GiftRegistriesArea();
      new FindRegistriesArea();
      window.registry_list_view = new RegistryListView();
      new EventTypeWatcher();
    }

    defaults () {
        return {
            registry_id: '',
            reg_firstname: '',
            reg_lastname: '',
            coreg_firstname: '',
            coreg_lastname: '',
            location_state: '',
            print_date: '',
            retailer_registry_id: '',
            retailer: '',
            retailer_logo: '',
            guest_url: '',
            registry_added: false
        };
    };

    clear () {
        return this.destroy();
    };

    sync () {};

    added () {
        return this.get('registry_added');
    };

};


var month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function parse_knot_date (datetime_str) {
    if (!datetime_str) {
        return datetime_str;
    }

    // Knots seems to have changed the date format from epoch to ISO at some point.
    //  date = new Date(parseInt(datetime_str.substr(6)))
    let date = new Date(datetime_str);
    return month_names[date.getUTCMonth()] + " " + date.getUTCDate() + ", " + date.getUTCFullYear();
};


function append_link_tracking (url, show_knot) {
    let tracking_params = {
        ss: 'RegistryPage',
        sp: 'TextLink',
        lt: 'RetailerGVR',
        st: 'ElectronicCard'
    };

    if (show_knot) {
        tracking_params['a'] = '2400';
    } else {
        tracking_params['a'] = '2410';
    }

    let tracking_params_str = $.param(tracking_params);
    return `${url}&${tracking_params_str}`;
};


// ------------------------------------------------------------------------
// -- RegistryCollection --------------------------------------------------
// ------------------------------------------------------------------------
class RegistryCollection extends Backbone.Collection {

    get model() {
        return RegistryModel;
    };

    add_all (data, show_knot=true) {
        this.reset(_.map(data, function(r) {
            return new RegistryModel({
                registry_id: r.Id,
                coreg_firstname: r.Registrant2FirstName,
                coreg_lastname: r.Registrant2LastName,
                guest_url: append_link_tracking(r.GuestViewUrl, show_knot),
                location_state: r.State,
                print_date: parse_knot_date(r.EventDate),
                reg_firstname: r.Registrant1FirstName,
                reg_lastname: r.Registrant1LastName,
                retailer_registry_id: r.RetailerId,
                retailer: r.RetailerName,
                retailer_logo: r.RetailerLogoURL
            });
        }));
    };

    clear_all () {
        this.reset();
    };

    added () {
        return _.filter(this.models, function(r) {
            return r.added();
        });
    };

    data_for_parent () {
        let results = [];
        for (let r of this.added()) {
            results.append(r.toJSON());
        }
        return results;
    };

    data_for_form_submit () {
        return _.map(this.added(), function(r) {
            return r.toJSON();
        });
    };

};


// ------------------------------------------------------------------------
// -- GiftRegistriesArea --------------------------------------------------
// ------------------------------------------------------------------------
class GiftRegistriesArea extends Backbone.View {

    el() {
        return '#registry';
    };

    get events() {
        return {
            'click .link-registries': 'registry_modal'
        };
    };

    registry_modal () {
        let event_type =
            evite.store.get('event.event_type') ||
            evite.store.get('template.event_type') ||
            // Deprecated forms of accessing event_type
            $('#id_event_type').val() ||
            window.event_type ||
            (window.client_data && window.client_data.event_type);

        if(!evite.store.get('event.event_type')){
            evite.store.set('event.event_type', event_type || '');
        }

        if ($('button.link-registries')) {
            let url = urls.get('modal_knot_link_registry') + '?event_type=' + event_type;
            new EviteModal({
                width: '1020px',
                url: url,
                clickOutside: false
            }).show();
        }
    };

};


// ------------------------------------------------------------------------
// -- FindRegistriesArea --------------------------------------------------
// ------------------------------------------------------------------------
class FindRegistriesArea extends Backbone.View {

    el() {
        return '#event_message';
    };

    get events() {
        return {
            'click button#find_registries': 'registry_modal'
        };
    };

    registry_modal (e) {
        e.preventDefault();
        let modal_knot_find_registry = urls.get('modal_knot_find_registry');
        new EviteModal({
            width: '1020px',
            url: `${modal_knot_find_registry}?event_type=${window.event_type}`,
            clickOutside: false
        }).show();
    };

};


// ------------------------------------------------------------------------
// -- Registry Item View --------------------------------------------------
// ------------------------------------------------------------------------
class RegistryItemView extends Backbone.View {

    get tagName() {
        return 'ul';
    };

    get template() {
        return _.template('<li>\n   <div><%= retailer %></div>\n   <div><a class="remove-registry" href="javascript:void(0);">Remove</a></div>\n</li>');
    };

    get events() {
        return {
            'click a.remove-registry': 'remove_registry'
        };
    };

    render () {
        this.$el.html(this.template(this.model.toJSON()));
        // for postmark header
        if ($('#header-nav-step')) {
            $("#header_spacer").height($('#header').outerHeight() + 24);
        }
        return this;
    };

    remove_registry () {
        this.model.set('registry_added', false);
        window.registry_list_view.populate_registry_list();
        if ($('#header-nav-step')) {
            $("#header_spacer").height($('#header').outerHeight());
        }
        if (!$('#id_registries').val()) {
            $('.add_registry').text('Add Wishlist');
        }
    };

};


// ------------------------------------------------------------------------
// -- Registry List View --------------------------------------------------
// ------------------------------------------------------------------------
class RegistryListView extends Backbone.View {

    el() {
        return '.registry-list';
    };

    initialize () {
        window.registry_collection.on('reset', this.populate_registry_list);
        let registries_on_load = $('#id_registries').val();
        if (registries_on_load) {
            let registries_data = JSON.parse(registries_on_load);
            for (let data of registries_data) {
                let registry = new RegistryModel({
                    registry_id: data.registry_id,
                    reg_firstname: data.reg_firstname,
                    reg_lastname: data.reg_lastname,
                    coreg_firstname: data.coreg_firstname,
                    coreg_lastname: data.coreg_lastname,
                    location_state: data.location_state,
                    print_date: data.print_date,
                    retailer_registry_id: data.retailer_registry_id,
                    retailer: data.retailer,
                    retailer_logo: data.retailer_logo,
                    guest_url: data.guest_url,
                    registry_added: true
                });
                window.registry_collection.add(registry);
            }
        }
        this.populate_registry_list();
    };

    populate_registry_list () {
        $(this.el).empty();
        let registry_input = $('#id_registries');

        let registry_data = "";
        if (window.registry_collection.added().length) {
            $('.your-registries').show();
            $('.add_registry').text('Edit Registries');
            for (let model of window.registry_collection.added()) {
                new RegistryItemView({
                    model: model
                }).render().$el.appendTo($(this.el));
            }

            registry_data = JSON.stringify(window.registry_collection.data_for_form_submit());
        } else {
            $('.your-registries').hide();
        }
        registry_input.val(registry_data);
        registry_input.trigger('change');
    };

};


class EventTypeWatcher extends Backbone.View {
    el() {
        return 'form';
    };

    get events() {
        return {
            'change #id_event_type': 'handle_id_event_type_change',
            'change #id_wishlist': 'check_for_addons',
            'change #id_registries': 'check_for_addons',
            'change #id_event_option_show_gifting': 'enable_gifting_changed',
            'change #id_event_option_enable_sponsored_registry': 'enable_sponsored_reg_changed'
        };
    };

    initialize () {
        this._giftsToggleElem = $('#id_event_option_show_gifting').first();
        this._sponsoredRegToggleElem = $('#id_event_option_enable_sponsored_registry').first();
        this.initGiftsToggleStates();

        this.listenTo(evite.store, 'change:event.event_type', this.handle_event_event_type_change);
        this.check_for_addons();
    };

    initGiftsToggleStates() {
      this._giftsChecked = this._giftsToggleElem.prop('checked');
      this._sponsoredRegChecked = this._sponsoredRegToggleElem.prop('checked');
    }

    handle_id_event_type_change(){
        let event_type = $('#id_event_type').val();
        const isPremium = (window.location.href.indexOf('plus') !== -1);

        if(event_type !== evite.store.get('event.event_type')) {
            evite.store.set('event.event_type', event_type || '');
        }

        if (isPremium) {
            // Reset premium frames to gifting options default if another had been open on event type change
            $('#donation_frame').addClass('hidden');
            $('#amazon_frame').addClass('hidden');
            $('#registry_frame').addClass('hidden');
            $('#gifting_frame').removeClass('hidden');
        }
    }

    handle_event_event_type_change(){
        let event_type = evite.store.get('event.event_type');
        const $id_event_type = $('#id_event_type');

        if(event_type && $id_event_type.val() !== event_type){
            $('#id_event_type').val(event_type).change();
        }

        this.check_for_addons();
    }

    enable_gifting_changed() {
      this._giftsChecked = this._giftsToggleElem.prop('checked');
    }

    enable_sponsored_reg_changed() {
      this._sponsoredRegChecked = this._sponsoredRegToggleElem.prop('checked');
    }

    check_for_addons () {
        let event_type = evite.store.get('event.event_type');

        $(window).trigger('change:event.event_type', [event_type]);
        this.show_registry_section(event_type);
        this.show_amazon_wishlist(event_type);
        this.show_sponsored_registry(event_type);
        this.show_other_gifting(event_type);
    };

    turn_registry_section_on (event_type) {
        let initial_registries = $('#id_registries').val();

        // if there is a wish list added, don't show registry button
        if ($('#id_wishlist').val() && $('#id_wishlist').val() !== '') {
            return false;
        }
        // if the event type is a registry type - show the registry button
        if (window.KNOT_EVENT_TYPES && window.KNOT_EVENT_TYPES.indexOf(event_type) >= 0) {
            return true;
        }

        if (window.BUMP_EVENT_TYPES && window.BUMP_EVENT_TYPES.indexOf(event_type) >= 0) {
            return true;
        }

        // if there is already a registry added, show the registry button
        else if (window.registry_collection.added().length) {
            return true;
        }
        // if the hidden registry input has a value already, still show the registry button
        else if (initial_registries !== '[]' && initial_registries !== '') {
            let event_type = $('#id_event_type').attr('orig_value');
            $(window).trigger('change:event.event_type', [event_type]);
            return true;
        }
        else {
          return false;
        }
    };
    show_amazon_wishlist (event_type) {
        var isPremium = (window.location.href.indexOf('plus') !== -1);
        $('#amazon_wishlist_container .wishlist').show();

        if (!this.turn_registry_section_on(event_type)) {
            if (isPremium) {
                $('.add_registry').addClass('hidden');
                $('.add_amazon_wishlist').removeClass('hidden');
            }
            else {
                $('#amazon_wishlist_container').removeClass('hidden');
            }
        } else {
            if (isPremium) {
                $('.add_amazon_wishlist').addClass('hidden');
                $('.add_registry').removeClass('hidden');

            }
            else {
                $('#amazon_wishlist_container').addClass('hidden');
            }
        }
    };

    show_registry_section (event_type) {
        var isPremium = (window.location.href.indexOf('plus') !== -1);

        if (!utils.isMobile() && !utils.isMobileDevice()) {
            if (window.KNOT_EVENT_TYPES && window.KNOT_EVENT_TYPES.indexOf(event_type) >= 0) {
                $('#powered_by_bump').hide();
                $('#powered_by_knot').show();
            }
            else if (window.BUMP_EVENT_TYPES && window.BUMP_EVENT_TYPES.indexOf(event_type) >= 0) {
                $('#powered_by_bump').show();
                $('#powered_by_knot').hide();
            }
        }

        if (this.turn_registry_section_on(event_type)) {
            if (isPremium) {
                $('.add_registry').removeClass('hidden');
                $('.add_amazon_wishlist').addClass('hidden');
            }
            else {
                $('#registry').removeClass('hidden')
            }
        } else {
            if (isPremium) {
                $('.add_registry').addClass('hidden');
                $('.add_amazon_wishlist').removeClass('hidden');
            }
            else {
                $('#registry').addClass('hidden');
            }
        }
    };

    is_sponsored_event_type(event_type){
        return Boolean(window.sponsored_registry_form_data && window.sponsored_registry_form_data[event_type])
    }

    show_sponsored_registry(event_type) {
      if (this.is_sponsored_event_type(event_type)) {
        // sponsored registry is available so show it and restore the checked value
        let enableMessageStr = window.sponsored_registry_form_data[event_type]['enable_message'];
        let logoImageUrl = window.sponsored_registry_form_data[event_type]['logo_image_url'];
        $('#sponsored_registry_enable_message').html(enableMessageStr);
        $('#sponsored_registry_logo_image').attr('src', logoImageUrl);
        this._sponsoredRegToggleElem.prop('checked', this._sponsoredRegChecked);
        $('#sponsored_registry_container').removeClass('hidden');
      } else {
        // no sponsored registry available so hide the option and turn it off
        $('#sponsored_registry_container').addClass('hidden');
        this._sponsoredRegToggleElem.prop('checked', false);
      }
    }

    show_other_gifting(event_type) {
    if (this.is_sponsored_event_type(event_type)) {
        // there's a sponsored registry available so hide the other gifts stuff and turn off the option
        $('#other_gifting_container').addClass('hidden');
        this._giftsToggleElem.prop('checked', false);
      } else {
        // no sponsored registry, so show the gifting option and restore the checked value
        this._giftsToggleElem.prop('checked', this._giftsChecked);
        $('#other_gifting_container').removeClass('hidden');
      }
    }
};

// TODO - remove
$(document).ready(RegistryModel.setup);



// WEBPACK FOOTER //
// ./assets/es6/common/theknot/registry_core.es6